<template>
  <div class="px-5 pb-2 pt-0 text-center">
    <div v-if="activePass">
      <h2 class="mb-4">End Pass</h2>
      <div>
        <div class="bg-light p-3 text-dark">
          <h5 class="mb-3">
            {{
              $helpers.transformDate(
                activePass.created_at,
                "dddd, DD, MMMM, YYYY"
              )
            }}
          </h5>
          <table class="w-100 text-start">
            <tr>
              <th>Time</th>
              <th>From</th>
              <th>To</th>
            </tr>
            <tr>
              <td>
                {{ $helpers.transformDate(activePass.created_at, "h:mm A") }}
              </td>
              <td>{{ activePass.from ? activePass.from.name : "" }}</td>
              <td>{{ activePass.to ? activePass.to.name : "" }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="d-flex mt-4 justify-content-center">
        <button
          class="mx-2 text-uppercase py-3 px-4 fw-bold w-50 btn bg-gradient-blue text-white lh-normal"
          @click="endPass()"
        >
          End Pass
        </button>
        <button
          class="mx-2 text-uppercase py-3 px-4 fw-bold w-50 btn appointment-pass-btn lh-normal btn-accent-light"
          @click="cancel()"
        >
          Cancel({{ timeout }})
        </button>
      </div>
      <CAlert
        class="mt-4 mb-0"
        :color="reqResponse.type"
        :show="!!reqResponse.message"
      >
        {{ reqResponse.message }}
      </CAlert>
      <div class="d-flex align-items-center justify-content-center mt-5">
        <a
          class="text-accent-blue-dark"
          target="_blank"
          href="https://eduspiresolutions.org/terms-of-use/"
          >Terms of Use</a
        >
        <span class="mx-2">|</span>
        <a
          class="text-accent-blue-dark"
          target="_blank"
          href="https://eduspiresolutions.org/privacy-policy/"
          >Privacy policy</a
        >
      </div>
    </div>
    <div v-else>
      <div class="pass-form-red m-0">
        <span class="flaticon-warning-1" />
      </div>
      <h2>You do not have an active pass.</h2>
      <p class="mb-1">This screen will be closed in {{ timeout }} seconds.</p>
      <p class="mt-0" @click="cancel()">(or click here to close it now)</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "EndPassForm",
  emits: ["tabChanged"],
  data() {
    return {
      isLoading: false,
      timeout: 20,
      interval: null,
      reqResponse: {
        type: "",
        message: null,
        errors: {}
      }
    }
  },
  computed: {
    ...mapGetters({
      activePass: "kiosks/activePass",
      activeKiosk: "kiosks/activeKiosk"
    }),
    isAutoPass() {
      return (
        this.activePass.flags.auto_pass &&
        this.activePass.flags.auto_pass.is_valid &&
        this.activePass.flags.auto_pass.mode === "start_and_stop"
      )
    }
  },
  mounted() {
    this.interval = setInterval(() => {
      if (this.timeout > 0) {
        this.timeout--
      } else {
        clearInterval(this.interval)
        this.cancel()
      }
    }, 1000)
  },
  unmounted() {
    clearInterval(this.interval)
  },
  methods: {
    endPass() {
      this.resetResponseMessages()
      if (this.activePass) {
        this.isLoading = true
        let data = {
          id: this.activePass.id,
          data: {
            action: 7,
            kiosk_id: this.activeKiosk.id
          }
        }
        let action = "kiosks/updatePass"

        if (this.isAutoPass) {
          action = "kiosks/autoApprovePass"
          data = {
            passId: this.activePass.id,
            action: 2,
            kiosk_id: this.activeKiosk.id
          }
        }
        this.$store
          .dispatch(action, data)
          .then(() => {
            this.isLoading = false
            this.setSuccessResponse("Your pass has successfully been ended.")
            setTimeout(() => {
              this.resetResponseMessages()
              this.cancel()
            }, 1000)
          })
          .catch((err) => {
            this.isLoading = false
            const response = err.response.data
            this.setErrorResponse(response.message, response.errors)
            this.isLoading = false
          })
      } else {
        this.cancel()
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Something went wrong!",
        errors: errors ? errors : {}
      }
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    cancel() {
      this.$store.dispatch("kiosks/userLogout")
      this.$emit("tabChanged", "mainScreen")
    }
  }
}
</script>
